module.exports = {"id":"183520","name":"Fran Mérida","rating":"73","photo":"./data/images/photos/2/183520.png","club":{"name":"CA Osasuna","logo":"./data/images/clubs/CAOsasuna.png"},"positions":["MDC","MC","MOC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/FranMerida0.json
// module id = 1461
// module chunks = 0